import FAQ1 from "./FAQ1";

const faqs = {
    1: FAQ1
};

export default faqs;